import { apiWithProject } from "./greenetworkAPI";

const END_POINT = "/devices/summaries/electric-meters-measures";

const getSummaries = (id, type, year, month, day, hour) => {
  return apiWithProject.get(
    `${END_POINT}/${id}?type=${type}&year=${year}${
      month ? `&month=${month}` : ""
    }${day ? `&day=${day}` : ""}${hour ? `&hour=${hour}` : ""}`
  );
};

const getMultipleSummaries = (deviceIds, type, year, month, day) => {
  let url = `${END_POINT}/multiple?deviceIds=${deviceIds.join(',')}&type=${type}&year=${year}`;
  if (month) url += `&month=${month}`;
  if (day)   url += `&day=${day}`;
  return apiWithProject.get(url);
};

const Summaries = {
  getSummaries,
  getMultipleSummaries,
};

export default Summaries;
